import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "cx-recovery modal-dialog" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { class: "modal-title" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = {
  key: 1,
  class: "cx-recovery__form"
}
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = { class: "password-recovery" }
const _hoisted_10 = {
  key: 0,
  class: "password-recovery__success"
}
const _hoisted_11 = {
  class: "alert alert-info",
  role: "alert"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "well" }
const _hoisted_14 = {
  key: 0,
  class: "errorlist"
}
const _hoisted_15 = { for: "id_username_or_email" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "lead" }
const _hoisted_19 = { class: "clearlist margin bottom" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_cx_spinner = _resolveComponent("cx-spinner")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("h4", _hoisted_4, _toDisplayString(_ctx.translations.recovery), 1)
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          (_ctx.isSilentLoginInProgress || _ctx.isSilentRedirectInProgress)
            ? (_openBlock(), _createBlock(_component_cx_spinner, {
                key: 0,
                loading: true,
                size: 120,
                color: "#2d84d7"
              }))
            : _createCommentVNode("", true),
          (!_ctx.isSilentLoginInProgress && !_ctx.isSilentRedirectInProgress)
            ? (_openBlock(), _createBlock("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, [
                  _createVNode("div", _hoisted_9, [
                    (_ctx.shouldDisplaySuccess)
                      ? (_openBlock(), _createBlock("div", _hoisted_10, [
                          _createVNode("div", _hoisted_11, _toDisplayString(_ctx.translations.recoveryEmailSent), 1),
                          _createVNode("button", {
                            class: "btn btn-default btn-block",
                            onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.navigateToLogin(...args)))
                          }, _toDisplayString(_ctx.translations.back), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.shouldDisplaySuccess)
                      ? (_openBlock(), _createBlock("form", _hoisted_12, [
                          _createVNode("div", _hoisted_13, [
                            (_ctx.currentErrorType)
                              ? (_openBlock(), _createBlock("ul", _hoisted_14, [
                                  _createVNode("li", null, _toDisplayString(_ctx.errorText), 1)
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode("label", _hoisted_15, _toDisplayString(_ctx.translations.username), 1),
                            _withDirectives(_createVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.username = $event)),
                              id: "id_username_or_email",
                              autocomplete: "off",
                              required: true
                            }, null, 512), [
                              [_vModelText, _ctx.username]
                            ]),
                            _createVNode("button", {
                              class: "btn btn-default btn-block",
                              onClick: _cache[3] || (_cache[3] = (...args) => (_ctx.recoverPassword(...args)))
                            }, [
                              (!_ctx.isRecoveryQueryInProgress)
                                ? (_openBlock(), _createBlock("span", _hoisted_16, _toDisplayString(_ctx.translations.reset), 1))
                                : _createCommentVNode("", true),
                              (_ctx.isRecoveryQueryInProgress)
                                ? (_openBlock(), _createBlock(_component_cx_spinner, {
                                    key: 1,
                                    loading: true,
                                    size: 20,
                                    color1: "white",
                                    stroke1: 2,
                                    stroke2: 0.5
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode("button", {
                              class: "btn btn-block",
                              onClick: _cache[4] || (_cache[4] = (...args) => (_ctx.navigateToLogin(...args)))
                            }, _toDisplayString(_ctx.translations.back), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_17, [
                  _createVNode("p", _hoisted_18, _toDisplayString(_ctx.translations.headline), 1),
                  _createVNode("ul", _hoisted_19, [
                    _createVNode("li", null, _toDisplayString(_ctx.translations.note), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}